module.exports = __webpack_public_path__ + "img/postk.79cc70d6.png";